module.exports = __webpack_public_path__ + "static/edit-html-0ff3b1e740597fb95fb5cf9913a2f7b7.mp4";